/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconPoint = createReactComponent("point", "IconPoint", [
  ["path", { d: "M12 12m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0", key: "svg-0" }]
]);

export { IconPoint as default };
//# sourceMappingURL=IconPoint.js.map
